import { ServiceDataFields } from './service-data-fields.enum';

export const niptFieldSet = [
  ServiceDataFields.GenderInformation,
  ServiceDataFields.IncidentalFindings,
  ServiceDataFields.PregnancyInformation,
  ServiceDataFields.DueDate,
  ServiceDataFields.PregnancyType,
  ServiceDataFields.Ivf,
  ServiceDataFields.VanishingTwinSyndrome,
  ServiceDataFields.HeparinTherapy,
  ServiceDataFields.DateOfUltrasound,
  ServiceDataFields.PriorScreeningTest,
  ServiceDataFields.PatientHistoryInformation,
  ServiceDataFields.ParaAndGravida,
  ServiceDataFields.ChromosomalAbnormalityCarrier,
  ServiceDataFields.PreviousPregnanciesGeneticCondition,
  ServiceDataFields.FamilyHistoryOfGeneticDiseases,
  ServiceDataFields.CarrierOfGeneticCondition,
  ServiceDataFields.HistoryOfCancer,
  ServiceDataFields.HumanSerumAlbuminTherapy,
  ServiceDataFields.CellularImmunotherapy,
  ServiceDataFields.StemCellTherapy,
  ServiceDataFields.TransplantSurgery,
  ServiceDataFields.BloodTransfusion,
  ServiceDataFields.AdditionalPatientInformation,
  ServiceDataFields.Weight,
  ServiceDataFields.Height,
  ServiceDataFields.DocumentNumber,
];
